module.exports = __webpack_public_path__ + "static/media/spotify~9fcde0824cd6ad815791a779010daa81ceaed303.4112a3a5.svg";